import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from '@cimpress/react-components';

const CimdocModal = ({ show, width, height, url, colorAdjustment, onClose }) => (
    <Modal
        className='cimdoc-modal'
        show={show}
        onRequestHide={onClose}
        closeButton={true}
        closeOnOutsideClick={true}
        title='Recolorization Cimdoc'
    >
        <pre className='highlight-block'>
            <code className='json hljs'>
                {'{\n'}
                <span className='hljs-attr'>version</span>: <span className='hljs-string'>{"'2.0'"}</span>{',\n'}
                <span className='hljs-attr'>document</span>: {'{\n    '}
                <span className='hljs-attr'>surfaces</span>: {'[{\n        '}
                <span className='hljs-attr'>name</span>: <span className='hljs-string'>{"'dummy-name'"}</span>{',\n        '}
                <span className='hljs-attr'>width</span>: <span className='hljs-number'>{width}</span>{',\n        '}
                <span className='hljs-attr'>height</span>: <span className='hljs-number'>{height}</span>{',\n        '}
                <span className='hljs-attr'>images</span>: {'[{\n            '}
                <span className='hljs-attr'>id</span>: <span className='hljs-string'>{"'dummy-id'"}</span>{',\n            '}
                <span className='hljs-attr'>printUrl</span>: <span className='hljs-string'>{`'${url}'`}</span>{',\n            '}
                <span className='hljs-attr'>previewUrl</span>: <span className='hljs-string'>{`'${url}'`}</span>{',\n            '}
                <span className='hljs-attr'>position</span>: {'{\n                '}
                <span className='hljs-attr'>x</span>: <span className='hljs-number'>0</span>{',\n                '}
                <span className='hljs-attr'>y</span>: <span className='hljs-number'>0</span>{',\n                '}
                <span className='hljs-attr'>width</span>: <span className='hljs-number'>{width}</span>{',\n                '}
                <span className='hljs-attr'>height</span>: <span className='hljs-number'>{height}</span>{',\n            '}
                {'},\n            '}
                <span className='hljs-attr'>colorAdjustment</span>: {'{\n                '}
                <span className='hljs-attr'>hueMultiplier</span>: <span className='hljs-number'>{colorAdjustment.hueMultiplier}</span>{',\n                '}
                <span className='hljs-attr'>hueOffset</span>: <span className='hljs-number'>{colorAdjustment.hueOffset}</span>{',\n                '}
                <span className='hljs-attr'>saturationMultiplier</span>: <span className='hljs-number'>{colorAdjustment.saturationMultiplier}</span>{',\n                '}
                <span className='hljs-attr'>saturationOffset</span>: <span className='hljs-number'>{colorAdjustment.saturationOffset}</span>{',\n                '}
                <span className='hljs-attr'>lightnessMultiplier</span>: <span className='hljs-number'>{colorAdjustment.lightnessMultiplier}</span>{',\n                '}
                <span className='hljs-attr'>lightnessOffset</span>: <span className='hljs-number'>{colorAdjustment.lightnessOffset}</span>{',\n            '}
                {'},\n        '}
                {'}],\n    '}
                {'}],\n'}
                {'}'}
            </code>
        </pre>
    </Modal>
);

export default CimdocModal;

CimdocModal.propTypes = {
    show: PropTypes.bool,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    url: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    colorAdjustment: PropTypes.shape({
        hueMultiplier: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        hueOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        saturationMultiplier: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        saturationOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        lightnessMultiplier: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
        lightnessOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    }),
};



// WEBPACK FOOTER //
// ./src/components/recolorization/cimdocModal.jsx